import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SCREEN_TYPES } from '@/utils/constants';
import TextInfo, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_FONT_WEIGHT,
  TEXT_WRAP,
  TEXT_DECORATION,
} from "@gc-npm/components.text";
import CustomLink from '@gc-npm/components.custom-link';
import { actions as modalActions } from '@gc-npm/reducers.modals-reducer';
import LegalsModalPrices from '@/components/Modals/LegalsModalPrices';
import {
  CONTENT_POSITION,
  IN_SCENE_EFFECT,
  OUT_SCENE_EFFECT,
} from '@gc-npm/components.modal';

export const UpgradePrices = () => {
  const dispatch = useDispatch();
  
  const modulos = useSelector((state) => state.modulos);
  const screenType = useSelector((state) => state.UI.screenType);

  const COMPONENT_NAME = 'section';

  const taggingInfo = {
      componentContent: COMPONENT_NAME,
      componentName: "UpgradePrices",
      componentProduct: '',
      componentVariation: 'All',
      eventType: 'click',
    };

  const showLegalsModalPrices = (legalTexts) => {
    const data = {
      legals: legalTexts,
    };

    dispatch(
      modalActions.addModal({
        id: 'LegalsModalPrices',
        Element2Show: LegalsModalPrices,
        modalProps: {
          closeByClickingOutside: true,
          contentPosition:
            screenType === SCREEN_TYPES.MOBILE
              ? CONTENT_POSITION.CENTER_BOTTOM
              : CONTENT_POSITION.RIGHT_CENTER,
          inSceneEffect:
            screenType === SCREEN_TYPES.MOBILE
              ? IN_SCENE_EFFECT.FADE_IN_BOTTOM
              : IN_SCENE_EFFECT.RIGHT_CENTER,
          outSceneEffect:
            screenType === SCREEN_TYPES.MOBILE
              ? OUT_SCENE_EFFECT.FADE_OUT_BOTTOM
              : OUT_SCENE_EFFECT.RIGHT_CENTER,
          opacityLayoutColor: 'blur',
          scrollAllowed: true,
        },
        elementProps: {
          screenType,
          data,
        },
      }),
    );
  }

  return (
    <>
      <main className="UpgradePrices">
        {modulos && (
          <div className="sections">
            {modulos?.legalTexts && (
              <div className="legals">
                <TextInfo
                  text={modulos.legalTexts.textInfo.replace(',', '')}
                  color={TEXT_COLOR.GREY5}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                  size={TEXT_SIZE.CAPTION}
                  wrap={TEXT_WRAP.WRAP}
                  align="left"
                  className="legals__title"
                />
                <CustomLink
                  taggingInfo={{
                    ...taggingInfo,
                    componentProduct: `text--${modulos?.legalTexts?.legalLinkText}`,
                  }}
                  onClick={() => showLegalsModalPrices(modulos?.legalTexts)}
                >
                  <TextInfo
                    text={modulos.legalTexts.legalLinkText}
                    size={TEXT_SIZE.CAPTION}
                    color={TEXT_COLOR.MOVISTAR_BLUE}
                    fontType={TEXT_FONT_WEIGHT.REGULAR}
                    decoration={TEXT_DECORATION.UNDERLINE}
                  />
                </CustomLink>
              </div>
            )}
          </div>
        )}
      </main>
      <style jsx>
        {`
          .UpgradePrices {
            padding-top: 1rem;
            display: grid;
            grid-template-columns: auto;
            justify-content: space-between;
          }
          .sections {
            display: flex;
            flex-direction: column;
            gap: 2rem;
            // margin-top:1.5rem;
            
          }
          .legals {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
          }
 
          :global(.legals__title) {
            padding-right:0.4rem;
          }

 
          @media screen and (max-width: 768px) {
            .UpgradePrices {
              grid-template-columns: 100%;
              gap: 1rem;
              margin-bottom: 0rem;
            }
          }
        `}
      </style>
    </>
  );
};

export default UpgradePrices;
